import { useDispatch, useSelector } from 'react-redux'
import {ModalBase} from '../ModalBase'
import { State } from '../../../reducers';
import { generalCloseModalMessage } from '../../../actions/general.actions';

const ModalMessage = (props: any) => {
  const {title, message} = useSelector((state: State) => state.general.modalMessage);
  const dispatch = useDispatch();

  const handleClose = () => dispatch(generalCloseModalMessage());

  return (
    <ModalBase>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{title}</h3>
          </div>
          <div className='form-separator'></div>
          <p>
            {message}
          </p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button 
              className='m button w-inline-block' 
              onClick={handleClose}
            >
              <div>Aceptar</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalMessage
